module.exports = __webpack_public_path__ + "static/media/add_accreditation_documents.52b08785.svg";